import React, { useEffect, useRef, useState } from 'react';
import './OccupancyBarMinimal.css';

const API_URL = 'https://r3rflvh0wb.execute-api.eu-central-1.amazonaws.com/occupancy';
const REFRESH_INTERVAL = 150000; // aktualizace každých 2.5 minuty
const RETRY_INTERVAL = 30000; // opakovaný pokus po chybě, dokud nemáme první data
const FETCH_TIMEOUT = 15000; // limit na odpověď (studený start lambdy)

const OccupancyBarMinimal = () => {
    const [occupancyData, setOccupancyData] = useState(null);
    const [failed, setFailed] = useState(false);
    const dataRef = useRef(null);

    useEffect(() => {
        let disposed = false;
        let retryTimer = null;

        const fetchOccupancy = async () => {
            const controller = new AbortController();
            const timeout = setTimeout(() => controller.abort(), FETCH_TIMEOUT);
            try {
                const response = await fetch(API_URL, { signal: controller.signal });
                if (!response.ok) throw new Error(`HTTP ${response.status}`);
                const data = await response.json();
                if (!data || !Number.isFinite(Number(data.percentage))) {
                    throw new Error('Invalid occupancy payload');
                }
                if (disposed) return;
                dataRef.current = data;
                setOccupancyData(data);
                setFailed(false);
            } catch (error) {
                console.error('Error fetching occupancy:', error);
                if (disposed) return;
                // poslední známá data necháváme zobrazená, chybu ukazujeme jen bez dat
                if (!dataRef.current) {
                    setFailed(true);
                    clearTimeout(retryTimer);
                    retryTimer = setTimeout(fetchOccupancy, RETRY_INTERVAL);
                }
            } finally {
                clearTimeout(timeout);
            }
        };

        fetchOccupancy();
        const interval = setInterval(fetchOccupancy, REFRESH_INTERVAL);
        return () => {
            disposed = true;
            clearTimeout(retryTimer);
            clearInterval(interval);
        };
    }, []);

    const occupancyPercentage = occupancyData
        ? Math.min(100, Math.max(0, Math.round(Number(occupancyData.percentage))))
        : null;

    const getProgressBarClass = () => {
        if (occupancyPercentage < 50) return 'progress-fill low';
        else if (occupancyPercentage < 80) return 'progress-fill medium';
        else return 'progress-fill high';
    };

    return (
        <div className="occupancy-minimal">
            <div className="occupancy-label">Aktuální obsazenost posilovny</div>
            {occupancyData ? (
                <>
                    <div className="progress-bar">
                        <div
                            className={getProgressBarClass()}
                            style={{ width: `${occupancyPercentage}%` }}
                        ></div>
                    </div>
                    <div className="percentage">{occupancyPercentage}%</div>
                </>
            ) : failed ? (
                <div className="occupancy-unavailable">Data momentálně nejsou dostupná</div>
            ) : (
                <>
                    <div className="progress-bar">
                        <div className="progress-fill progress-skeleton"></div>
                    </div>
                    <div className="percentage">
                        <span className="percentage-skeleton"></span>
                    </div>
                </>
            )}
        </div>
    );
};

export default OccupancyBarMinimal;
